import { createActions } from "../../utils";
import {
  questionnarieLoadTypes,
  questionnarieSaveTypes,
} from "./questionnaire.constants";

export const questionnarieLoadActions = createActions(questionnarieLoadTypes);
export const questionnarieSaveActions = createActions(questionnarieSaveTypes);
